export type Bonus = {
  number: string
  title: string
  /** Short title printed on the code-drawn cover. */
  short: string
  body: string
  /** Spine colour of the code-drawn cover. */
  accent: string
  /** Icon on the code-drawn cover. */
  icon: 'route' | 'book' | 'lifebuoy' | 'backpack' | 'scale'
  /** Optional rendered cover (square works best). When empty, a code-drawn cover is shown. */
  cover?: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Season Route Planner',
    short: 'Season Route Planner',
    body: 'Three ready-made season routes (soft-ball, mixed-track and hard-ball) that tell you which session to run each week for 24 weeks. Plus a blank planner to build your own, and what to skip if you miss a week. Pick your squad and start on Tuesday.',
    accent: 'bg-willow',
    icon: 'route',
    cover: 'https://cdn.magicpatterns.com/uploads/ho3ESrxMmWLjCJDnocAbrw/cr-bonus-1.png',
  },
  {
    number: '02',
    title: 'Cricket for the Volun-told Coach: The Game Explained in Plain English',
    short: 'Cricket for the Volun-told Coach',
    body: 'Never played? Read this on the sofa the night before: how cricket works in two pages, the fielding positions on one page and the 60 words your players will use.',
    accent: 'bg-sky',
    icon: 'book',
    cover: 'https://cdn.magicpatterns.com/uploads/cxLVKJiu9ihEkdse9XrcSk/cr-bonus-2.png',
  },
  {
    number: '03',
    title: 'When the Session Goes Sideways',
    short: 'When the Session Goes Sideways',
    body: 'Sixteen “if this happens, do this” cards for the moments no session plan covers: nobody is listening, two players fall out, a player is in tears, another team is on your nets, a child isn’t collected.',
    accent: 'bg-cherry',
    icon: 'lifebuoy',
    cover: 'https://cdn.magicpatterns.com/uploads/aZQWSQSPMHt19svUsCLDKv/cr-bonus-3.png',
  },
  {
    number: '04',
    title: 'Shoestring Kit Guide',
    short: 'Shoestring Kit Guide',
    body: 'Short on kit? What to buy first for the season, what to borrow, and 15 things you can make at home for your soft-ball stations. Helmets, pads and other protective kit are never swapped for home-made versions.',
    accent: 'bg-cone',
    icon: 'backpack',
    cover: 'https://cdn.magicpatterns.com/uploads/88Vs8VYk7MQXhcEqyzJ78S/cr-bonus-4.png',
  },
  {
    number: '05',
    title: 'Fair-Play Match Day Organiser',
    short: 'Fair-Play Match Day Organiser',
    body: 'Match day without the arguments: rotation sheets so every player bats, bowls and fields a fair share across the season, ready to fill in on the morning of the game.',
    accent: 'bg-grass',
    icon: 'scale',
    cover: 'https://cdn.magicpatterns.com/uploads/tGz4vYeojt6eovzcdE5Qsy/cr-bonus-5.png',
  },
]
